// extracted by mini-css-extract-plugin
export default {"title":"LogIn_title__hQ+mU","btnContainer":"LogIn_btnContainer__VrtLS","doneBtn":"LogIn_doneBtn__781qU","fpBtn":"LogIn_fpBtn__Z9it4","caBtn":"LogIn_caBtn__Z4IpP"};